import type { Gallery } from './interfaces/gallery.interface';

export const GALLERIES: Gallery[] = [
  {
    year: '2017',
    images: [
      'szebit__17_of_63_preview.webp',
      'szebit__32_of_63_preview.webp',
      'szebit__39_of_63_preview.webp',
      'szebit__40_of_63_preview.webp',
      'szebit__43_of_63_preview.webp',
      'szebit__47_of_63_preview.webp',
      'szebit__48_of_63_preview.webp',
      'szebit__50_of_63_preview.webp',
      'szebit__51_of_63_preview.webp',
      'szebit__53_of_63_preview.webp',
      'szebit__60_of_63_preview.webp',
      'szebit__66_of_32_preview.webp',
      'szebit__68_of_32_preview.webp',
      'szebit__73_of_32_preview.webp',
      'szebit__89_of_32_preview.webp',
      'szebit__90_of_32_preview.webp',
      'szebit__91_of_32_preview.webp',
    ],
  },
  {
    year: '2018',
    images: [
      'szebit_cam1_13_of_54.webp',
      'szebit_cam1_17_of_54.webp',
      'szebit_cam1_18_of_54.webp',
      'szebit_cam1_20_of_54.webp',
      'szebit_cam1_22_of_54.webp',
      'szebit_cam1_23_of_54.webp',
      'szebit_cam1_24_of_54.webp',
      'szebit_cam1_25_of_54.webp',
      'szebit_cam1_26_of_54.webp',
      'szebit_cam1_27_of_54.webp',
      'szebit_cam1_28_of_54.webp',
      'szebit_cam1_2_of_54.webp',
      'szebit_cam1_36_of_54.webp',
      'szebit_cam1_42_of_54.webp',
      'szebit_cam1_43_of_54.webp',
      'szebit_cam1_48_of_54.webp',
      'szebit_cam1_49_of_54.webp',
      'szebit_cam1_4_of_54.webp',
      'szebit_cam1_51_of_54.webp',
      'szebit_cam1_52_of_54.webp',
      'szebit_cam1_53_of_54.webp',
      'szebit_cam1_5_of_54.webp',
      'szebit_cam1_7_of_54.webp',
      'szebit_cam2_13_of_50.webp',
      'szebit_cam2_14_of_50.webp',
      'szebit_cam2_15_of_50.webp',
      'szebit_cam2_16_of_50.webp',
      'szebit_cam2_18_of_50.webp',
      'szebit_cam2_19_of_50.webp',
      'szebit_cam2_1_of_50.webp',
      'szebit_cam2_20_of_50.webp',
      'szebit_cam2_21_of_50.webp',
      'szebit_cam2_22_of_50.webp',
      'szebit_cam2_23_of_50.webp',
      'szebit_cam2_24_of_50.webp',
      'szebit_cam2_25_of_50.webp',
      'szebit_cam2_28_of_50.webp',
      'szebit_cam2_29_of_50.webp',
      'szebit_cam2_2_of_50.webp',
      'szebit_cam2_30_of_50.webp',
      'szebit_cam2_33_of_50.webp',
      'szebit_cam2_34_of_50.webp',
      'szebit_cam2_35_of_50.webp',
      'szebit_cam2_36_of_50.webp',
      'szebit_cam2_37_of_50.webp',
      'szebit_cam2_38_of_50.webp',
      'szebit_cam2_39_of_50.webp',
      'szebit_cam2_3_of_50.webp',
      'szebit_cam2_41_of_50.webp',
      'szebit_cam2_44_of_50.webp',
      'szebit_cam2_45_of_50.webp',
      'szebit_cam2_46_of_50.webp',
      'szebit_cam2_48_of_50.webp',
      'szebit_cam2_49_of_50.webp',
      'szebit_cam2_4_of_50.webp',
      'szebit_cam2_6_of_50.webp',
      'szebit_cam2_7_of_50.webp',
      'szebit_cam2_9_of_50.webp',
    ],
  },
  {
    year: '2019',
    images: [
      'DSC_7955.webp',
      'DSC_7982.webp',
      'DSC_8046.webp',
      'DSC_8067.webp',
      'DSC_8132.webp',
      'DSC_8140.webp',
      'DSC_8236.webp',
      'DSC_8255.webp',
      'DSC_8333.webp',
      'DSC_8378.webp',
      'DSC_8430-2.webp',
      'DSC_8441.webp',
      'DSC_8519.webp',
      'DSC_8586-2.webp',
      'DSC_8620.webp',
      'DSC_8639.webp',
      'DSC_8645.webp',
      'DSC_8843.webp',
      'DSC_8869.webp',
      'DSC_8963.webp',
    ],
  },
  {
    year: '2022',
    images: [
      'szebit_22_100_of_130.webp',
      'szebit_22_101_of_130.webp',
      'szebit_22_102_of_130.webp',
      'szebit_22_103_of_130.webp',
      'szebit_22_104_of_130.webp',
      'szebit_22_105_of_130.webp',
      'szebit_22_106_of_130.webp',
      'szebit_22_107_of_130.webp',
      'szebit_22_108_of_130.webp',
      'szebit_22_109_of_130.webp',
      'szebit_22_10_of_130.webp',
      'szebit_22_110_of_130.webp',
      'szebit_22_111_of_130.webp',
      'szebit_22_112_of_130.webp',
      'szebit_22_113_of_130.webp',
      'szebit_22_114_of_130.webp',
      'szebit_22_115_of_130.webp',
      'szebit_22_116_of_130.webp',
      'szebit_22_117_of_130.webp',
      'szebit_22_118_of_130.webp',
      'szebit_22_119_of_130.webp',
      'szebit_22_11_of_130.webp',
      'szebit_22_120_of_130.webp',
      'szebit_22_121_of_130.webp',
      'szebit_22_122_of_130.webp',
      'szebit_22_123_of_130.webp',
      'szebit_22_124_of_130.webp',
      'szebit_22_12_of_130.webp',
      'szebit_22_13_of_130.webp',
      'szebit_22_14_of_130.webp',
      'szebit_22_15_of_130.webp',
      'szebit_22_16_of_130.webp',
      'szebit_22_17_of_130.webp',
      'szebit_22_18_of_130.webp',
      'szebit_22_19_of_130.webp',
      'szebit_22_1_of_130.webp',
      'szebit_22_20_of_130.webp',
      'szebit_22_21_of_130.webp',
      'szebit_22_22_of_130.webp',
      'szebit_22_23_of_130.webp',
      'szebit_22_24_of_130.webp',
      'szebit_22_25_of_130.webp',
      'szebit_22_26_of_130.webp',
      'szebit_22_27_of_130.webp',
      'szebit_22_28_of_130.webp',
      'szebit_22_29_of_130.webp',
      'szebit_22_2_of_130.webp',
      'szebit_22_30_of_130.webp',
      'szebit_22_31_of_130.webp',
      'szebit_22_32_of_130.webp',
      'szebit_22_33_of_130.webp',
      'szebit_22_34_of_130.webp',
      'szebit_22_35_of_130.webp',
      'szebit_22_36_of_130.webp',
      'szebit_22_37_of_130.webp',
      'szebit_22_38_of_130.webp',
      'szebit_22_39_of_130.webp',
      'szebit_22_3_of_130.webp',
      'szebit_22_40_of_130.webp',
      'szebit_22_41_of_130.webp',
      'szebit_22_42_of_130.webp',
      'szebit_22_43_of_130.webp',
      'szebit_22_44_of_130.webp',
      'szebit_22_45_of_130.webp',
      'szebit_22_46_of_130.webp',
      'szebit_22_47_of_130.webp',
      'szebit_22_48_of_130.webp',
      'szebit_22_49_of_130.webp',
      'szebit_22_4_of_130.webp',
      'szebit_22_50_of_130.webp',
      'szebit_22_51_of_130.webp',
      'szebit_22_52_of_130.webp',
      'szebit_22_53_of_130.webp',
      'szebit_22_54_of_130.webp',
      'szebit_22_55_of_130.webp',
      'szebit_22_56_of_130.webp',
      'szebit_22_57_of_130.webp',
      'szebit_22_58_of_130.webp',
      'szebit_22_59_of_130.webp',
      'szebit_22_5_of_130.webp',
      'szebit_22_60_of_130.webp',
      'szebit_22_61_of_130.webp',
      'szebit_22_62_of_130.webp',
      'szebit_22_63_of_130.webp',
      'szebit_22_64_of_130.webp',
      'szebit_22_65_of_130.webp',
      'szebit_22_66_of_130.webp',
      'szebit_22_67_of_130.webp',
      'szebit_22_68_of_130.webp',
      'szebit_22_69_of_130.webp',
      'szebit_22_6_of_130.webp',
      'szebit_22_70_of_130.webp',
      'szebit_22_71_of_130.webp',
      'szebit_22_72_of_130.webp',
      'szebit_22_73_of_130.webp',
      'szebit_22_74_of_130.webp',
      'szebit_22_75_of_130.webp',
      'szebit_22_76_of_130.webp',
      'szebit_22_77_of_130.webp',
      'szebit_22_78_of_130.webp',
      'szebit_22_79_of_130.webp',
      'szebit_22_7_of_130.webp',
      'szebit_22_80_of_130.webp',
      'szebit_22_81_of_130.webp',
      'szebit_22_82_of_130.webp',
      'szebit_22_83_of_130.webp',
      'szebit_22_84_of_130.webp',
      'szebit_22_85_of_130.webp',
      'szebit_22_86_of_130.webp',
      'szebit_22_87_of_130.webp',
      'szebit_22_88_of_130.webp',
      'szebit_22_89_of_130.webp',
      'szebit_22_8_of_130.webp',
      'szebit_22_90_of_130.webp',
      'szebit_22_91_of_130.webp',
      'szebit_22_92_of_130.webp',
      'szebit_22_93_of_130.webp',
      'szebit_22_94_of_130.webp',
      'szebit_22_95_of_130.webp',
      'szebit_22_96_of_130.webp',
      'szebit_22_97_of_130.webp',
      'szebit_22_98_of_130.webp',
      'szebit_22_99_of_130.webp',
      'szebit_22_9_of_130.webp',
      'szebit_22_tel_10_of_15.webp',
      'szebit_22_tel_11_of_15.webp',
      'szebit_22_tel_12_of_15.webp',
      'szebit_22_tel_13_of_15.webp',
      'szebit_22_tel_14_of_15.webp',
      'szebit_22_tel_15_of_15.webp',
      'szebit_22_tel_1_of_15.webp',
      'szebit_22_tel_2_of_15.webp',
      'szebit_22_tel_3_of_15.webp',
      'szebit_22_tel_4_of_15.webp',
      'szebit_22_tel_5_of_15.webp',
      'szebit_22_tel_6_of_15.webp',
      'szebit_22_tel_7_of_15.webp',
      'szebit_22_tel_8_of_15.webp',
      'szebit_22_tel_9_of_15.webp',
    ],
  },
  {
    year: '2023',
    images: [
      'szebit2023_101_of_217.webp',
      'szebit2023_104_of_217.webp',
      'szebit2023_105_of_217.webp',
      'szebit2023_107_of_217.webp',
      'szebit2023_109_of_217.webp',
      'szebit2023_10_of_217.webp',
      'szebit2023_110_of_217.webp',
      'szebit2023_111_of_217.webp',
      'szebit2023_112_of_217.webp',
      'szebit2023_113_of_217.webp',
      'szebit2023_115_of_217.webp',
      'szebit2023_116_of_217.webp',
      'szebit2023_118_of_217.webp',
      'szebit2023_121_of_217.webp',
      'szebit2023_122_of_217.webp',
      'szebit2023_125_of_217.webp',
      'szebit2023_126_of_217.webp',
      'szebit2023_127_of_217.webp',
      'szebit2023_129_of_217.webp',
      'szebit2023_12_of_217.webp',
      'szebit2023_130_of_217.webp',
      'szebit2023_132_of_217.webp',
      'szebit2023_133_of_217.webp',
      'szebit2023_135_of_217.webp',
      'szebit2023_139_of_217.webp',
      'szebit2023_140_of_217.webp',
      'szebit2023_144_of_217.webp',
      'szebit2023_145_of_217.webp',
      'szebit2023_146_of_217.webp',
      'szebit2023_147_of_217.webp',
      'szebit2023_148_of_217.webp',
      'szebit2023_149_of_217.webp',
      'szebit2023_150_of_217.webp',
      'szebit2023_151_of_217.webp',
      'szebit2023_152_of_217.webp',
      'szebit2023_154_of_217.webp',
      'szebit2023_155_of_217.webp',
      'szebit2023_157_of_217.webp',
      'szebit2023_158_of_217.webp',
      'szebit2023_159_of_217.webp',
      'szebit2023_15_of_217.webp',
      'szebit2023_164_of_217.webp',
      'szebit2023_166_of_217.webp',
      'szebit2023_169_of_217.webp',
      'szebit2023_16_of_217.webp',
      'szebit2023_170_of_217.webp',
      'szebit2023_172_of_217.webp',
      'szebit2023_173_of_217.webp',
      'szebit2023_176_of_217.webp',
      'szebit2023_177_of_217.webp',
      'szebit2023_178_of_217.webp',
      'szebit2023_179_of_217.webp',
      'szebit2023_17_of_217.webp',
      'szebit2023_180_of_217.webp',
      'szebit2023_181_of_217.webp',
      'szebit2023_182_of_217.webp',
      'szebit2023_183_of_217.webp',
      'szebit2023_184_of_217.webp',
      'szebit2023_185_of_217.webp',
      'szebit2023_186_of_217.webp',
      'szebit2023_187_of_217.webp',
      'szebit2023_188_of_217.webp',
      'szebit2023_189_of_217.webp',
      'szebit2023_18_of_217.webp',
      'szebit2023_191_of_217.webp',
      'szebit2023_194_of_217.webp',
      'szebit2023_196_of_217.webp',
      'szebit2023_197_of_217.webp',
      'szebit2023_198_of_217.webp',
      'szebit2023_1_of_217.webp',
      'szebit2023_200_of_217.webp',
      'szebit2023_201_of_217.webp',
      'szebit2023_202_of_217.webp',
      'szebit2023_203_of_217.webp',
      'szebit2023_204_of_217.webp',
      'szebit2023_205_of_217.webp',
      'szebit2023_206_of_217.webp',
      'szebit2023_207_of_217.webp',
      'szebit2023_208_of_217.webp',
      'szebit2023_209_of_217.webp',
      'szebit2023_210_of_217.webp',
      'szebit2023_213_of_217.webp',
      'szebit2023_214_of_217.webp',
      'szebit2023_215_of_217.webp',
      'szebit2023_216_of_217.webp',
      'szebit2023_217_of_217.webp',
      'szebit2023_22_of_217.webp',
      'szebit2023_24_of_217.webp',
      'szebit2023_27_of_217.webp',
      'szebit2023_28_of_217.webp',
      'szebit2023_30_of_217.webp',
      'szebit2023_32_of_217.webp',
      'szebit2023_34_of_217.webp',
      'szebit2023_35_of_217.webp',
      'szebit2023_38_of_217.webp',
      'szebit2023_39_of_217.webp',
      'szebit2023_3_of_217.webp',
      'szebit2023_40_of_217.webp',
      'szebit2023_41_of_217.webp',
      'szebit2023_44_of_217.webp',
      'szebit2023_45_of_217.webp',
      'szebit2023_46_of_217.webp',
      'szebit2023_49_of_217.webp',
      'szebit2023_52_of_217.webp',
      'szebit2023_54_of_217.webp',
      'szebit2023_55_of_217.webp',
      'szebit2023_56_of_217.webp',
      'szebit2023_5_of_217.webp',
      'szebit2023_60_of_217.webp',
      'szebit2023_62_of_217.webp',
      'szebit2023_64_of_217.webp',
      'szebit2023_66_of_217.webp',
      'szebit2023_67_of_217.webp',
      'szebit2023_6_of_217.webp',
      'szebit2023_70_of_217.webp',
      'szebit2023_71_of_217.webp',
      'szebit2023_73_of_217.webp',
      'szebit2023_75_of_217.webp',
      'szebit2023_76_of_217.webp',
      'szebit2023_77_of_217.webp',
      'szebit2023_7_of_217.webp',
      'szebit2023_82_of_217.webp',
      'szebit2023_83_of_217.webp',
      'szebit2023_84_of_217.webp',
      'szebit2023_87_of_217.webp',
      'szebit2023_88_of_217.webp',
      'szebit2023_89_of_217.webp',
      'szebit2023_90_of_217.webp',
      'szebit2023_91_of_217.webp',
      'szebit2023_92_of_217.webp',
      'szebit2023_94_of_217.webp',
      'szebit2023_95_of_217.webp',
      'szebit2023_97_of_217.webp',
      'szebit2023_98_of_217.webp',
      'szebit2023_9_of_217.webp',
    ],
  },
  {
    year: '2024',
    images: [
      'szebit_2024_63_of_226.webp',
      'szebit_2024_70_of_226.webp',
      'szebit_2024_76_of_226.webp',
      'szebit_2024_77_of_226.webp',
      'szebit_2024_81_of_226.webp',
      'szebit_2024_99_of_226.webp',
      'szebit_2024_116_of_226.webp',
      'szebit_2024_117_of_226.webp',
      'szebit_2024_120_of_226.webp',
      'szebit_2024_122_of_226.webp',
      'szebit_2024_132_of_226.webp',
      'szebit_2024_139_of_226.webp',
      'szebit_2024_142_of_226.webp',
      'szebit_2024_171_of_226.webp',
      'szebit_2024_179_of_226.webp',
      'szebit_2024_184_of_226.webp',
      'szebit_2024_197_of_226.webp',
      'szebit_2024_211_of_226.webp',
      'szebit_2024_214_of_226.webp',
      'szebit_2024_217_of_226.webp',
    ],
  },
  {
    year: '2025',
    images: [
      'p1080310.webp',
      'p1080311.webp',
      'p1080314.webp',
      'p1080344.webp',
      'p1080352.webp',
      'p1080368.webp',
      'p1080369.webp',
      'p1080370.webp',
      'p1080373.webp',
      'p1080374.webp',
      'p1080377.webp',
      'p1080380.webp',
      'p1080383.webp',
      'p1080385.webp',
      'p1080386.webp',
      'p1080396.webp',
      'p1080397.webp',
      'p1080409.webp',
      'p1080416.webp',
      'p1080424.webp',
      'p1080428.webp',
      'p1080429.webp',
      'p1080438.webp',
      'p1080441.webp',
      'p1080451.webp',
      'p1080454.webp',
      'p1080457.webp',
      'p1080458.webp',
      'p1080476.webp',
      'p1080483.webp',
      'p1080487.webp',
      'p1080495.webp',
      'p1080507.webp',
      'p1080511.webp',
      'p1080516.webp',
      'p1080531.webp',
      'p1080537.webp',
      'p1080550.webp',
      'p1080561.webp',
      'p1080562.webp',
      'p1080570.webp',
      'p1080573.webp',
      'p1080585.webp',
      'p1080588.webp',
      'p1080599.webp',
      'p1080601.webp',
      'p1080604.webp',
      'p1080614.webp',
      'p1080617.webp',
      'p1080626.webp',
      'p1080633.webp',
      'p1080639.webp',
      'p1080641.webp',
      'p1080644.webp',
      'p1080649.webp',
      'p1080655.webp',
      'p1080664.webp',
      'p1080678.webp',
      'p1080682.webp',
      'p1080688.webp',
      'p1080715.webp',
      'p1080730.webp',
      'p1080763.webp',
      'p1080775.webp',
      'p1080779.webp',
      'p1080783.webp',
      'p1080787.webp',
      'p1080803.webp',
      'p1080811.webp',
      'p1080815.webp',
      'p1080832.webp',
      'p1080838.webp',
      'p1080857.webp',
      'p1080858.webp',
      'p1080861.webp',
      'p1080866.webp',
      'p1080870.webp',
      'p1080872.webp',
      'p1080874.webp',
      'p1080878.webp',
      'p1080886.webp',
      'p1080892.webp',
      'p1080897.webp',
      'p1080902.webp',
      'p1080903.webp',
      'p1080910.webp',
      'p1080914.webp',
      'p1080944.webp',
      'p1080952.webp',
      'p1080965.webp',
      'p1080994.webp',
      'p1080995.webp',
      'p1080998.webp',
      'p1080999.webp',
      'p1081007.webp',
      'p1081020.webp',
      'p1081028.webp',
      'p1081031.webp',
      'p1081032.webp',
      'p1081033.webp',
      'p1081034.webp',
      'p1081036.webp',
      'p1081048.webp',
      'p1081064.webp',
      'p1081066.webp',
      'p1081067.webp',
      'p1081068.webp',
      'p1081070.webp',
      'p1081074.webp',
      'p1081092.webp',
      'p1081098.webp',
      'p1081104.webp',
      'p1081107.webp',
      'p1081109.webp',
      'p1081112.webp',
      'p1081113.webp',
      'p1081115.webp',
      'p1081117.webp',
      'p1081129.webp',
      'p1081130.webp',
      'p1081138.webp',
      'p1081161.webp',
      'p1081170.webp',
      'p1091324.webp',
      'p1101170.webp',
      'p1101187.webp',
      'p1101238.webp',
      'p1101243.webp',
      'p1101250.webp',
      'p1101338.webp',
      'pman8416.webp',
      'pman8498.webp',
      'pman8521.webp',
    ],
  },
];
